import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "install" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = {
  key: 0,
  class: "steps"
}
const _hoisted_6 = { class: "step" }
const _hoisted_7 = { class: "step" }
const _hoisted_8 = { class: "step" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "dialog-class": "pwa-install-dialog",
    min_width: "0",
    max_width: "36rem",
    blur: ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, " Add " + _toDisplayString($options.app_name) + " to your Home Screen ", 1 /* TEXT */),
          _createVNode(_component_Icon, {
            icon: "x",
            size: "2rem",
            stroke: "var(--brand-25)",
            onClick: $options.dismiss
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, " Get quick access to " + _toDisplayString($options.app_name) + " right from your Home Screen. ", 1 /* TEXT */),
        ($options.ios)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Icon, {
                  icon: "dots-horizontal",
                  stroke: "var(--brand-25)",
                  size: "2rem"
                }),
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "Tap More if you don't see Share", -1 /* HOISTED */))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Icon, {
                  icon: "share",
                  stroke: "var(--brand-25)",
                  size: "2rem"
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Tap Share", -1 /* HOISTED */))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Icon, {
                  icon: "square-plus",
                  size: "2rem",
                  stroke: "var(--brand-25)"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Tap “Add to Home Screen”", -1 /* HOISTED */))
              ])
            ]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "install-button",
              gap: "1.6rem",
              onClick: $options.install
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "square-plus",
                  size: "2rem",
                  stroke: "var(--brand-25)"
                }),
                _cache[3] || (_cache[3] = _createTextVNode(" Add to Home Screen "))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}